import {useEffect, useState} from "react";
import {Layout, LayoutChild} from '../../../../../palette/Palette';
import {Filters, UpdateArray} from '../../../../../utils/HelpFunctions';
import DashedLine from '../../../../../palette/DashedLine';
import {Button} from 'devextreme-react/button';
import {useSnackbar} from 'notistack';
import {ErrorMessage, NotiStackInfo} from "../../../../../palette/NotiStackInfo";
import axios from 'axios';
import ComponentLoadPanel from '../../../../../palette/LoadPanel';
import format from "date-fns/format";
import {es} from "date-fns/locale";
import Text from "../../../../../palette/Text";
import VerticalSpace from "../../../../../palette/VerticalSpace";
import TextArea from 'devextreme-react/text-area';
import {CheckBox} from 'devextreme-react/check-box';
import Invoice from "../Invoice";
import {customScroll} from "../../../../../utils/Scroll";
import {Element} from 'react-scroll'
import Alerts from "../../../../../palette/Alerts";

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

//const url = 'http://192.168.100.3:8083/reservations';

const url = 'https://trip-reservations-easi4xatjq-uc.a.run.app/reservations';

function Details(props) {
    const {
        total, bookings, hour, companyName, idCompany, dataPassengers, setBookings, setDriverId, checkBoxValue,
        tokenPush, logoUrl, contactNumbers, setDetailValue, driverId, setCheckBoxValue, detailValue, setVisibleGrid,
        setReservationManual, setTokenPush, driver,
    } = props;

    const [popupVisible, setPopupVisible] = useState(false);
    const [invoice, setInvoice] = useState({
        name: `${dataPassengers.name} ${dataPassengers.lastName}`,
        RUC: dataPassengers.idUser,
        contactNumber: dataPassengers.contactNumber,
        email: dataPassengers.email,
        address: '',
    });

    const [showPanel, setShowPanel] = useState(false);
    const [success, setSuccess] = useState(false);

    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        setShowPanel(false);
    }, [])

    const route = `${bookings[0].passengers[0].coords.origenCity}-${bookings[0].passengers[0].coords.destinyCity}`;

    const renderCancelButton = () => {
        return (
            <Layout row positionL>
                <Button id="cancel-button"
                        icon="fas fa-ban"
                        text="Cancelar viaje"
                        onClick={() => {
                            setVisibleGrid(true)
                            setReservationManual(false)
                            setTokenPush([])
                        }}/>
            </Layout>
        )
    }

    const updateDetails = (values) => {
        setDetailValue(values);

        const passenger = `${dataPassengers.name} ${dataPassengers.lastName}`;
        const filterDriver = Filters(bookings, 'driverId', driverId);

        const updatePassenger = UpdateArray(filterDriver[0].passengers, 'name', passenger,
            'details', values);

        const updateBooking = UpdateArray(bookings, 'driverId', driverId, 'passengers', updatePassenger);
        setBookings(updateBooking);
    };

    const onValueChanged = (args) => {
        if (args.value) {
            setDriverId(driverId);
            setDetailValue('');
        }
        customScroll('bottom-element', 500)
        setCheckBoxValue(args.value);
    };

    const onSaveReservation = async () => {

        bookings.forEach(seating => {
            seating.seating.forEach(seating => {
                if (seating.reservation) {
                    seating.value = false;
                }
            });
        });

        const passengerName = `${dataPassengers.name} ${dataPassengers.lastName}`;
        const contactNumber = dataPassengers.contactNumber

        const bookingHistoryArray = []
        const travelStatusArray = []

        bookings.forEach((booking) => {

            const formatDate = booking.date.replaceAll('-', '/')
            const date = new Date(formatDate)
            const year = format(date, 'yyyy');
            const month = format(date, 'MMMM', {locale: es});

            const routeName = bookings[0].routeName.split('-')

            const dataPassenger = Filters(booking.passengers, "contactNumber", contactNumber)

            let direction;
            let detail;
            let cod;

            if (dataPassenger.length > 1) {
                direction = dataPassenger[dataPassenger.length - 1].coords
                detail = dataPassenger[dataPassenger.length - 1].details
                cod = dataPassenger[dataPassenger.length - 1].cod
            } else {
                direction = dataPassenger[0].coords
                detail = dataPassenger[0].details
                cod = dataPassenger[0].cod
            }

            const paymentValue = Filters(booking.passengers, 'cod', cod)
            const numberSeats = Filters(booking.seating, 'cod', cod)
            const totalSeats = Filters(booking.seating, 'reservation', true)

            const bookingHistory = {
                cod: cod,
                date: booking.date,
                driver: booking.driver,
                driverId: booking.driverId,
                routeName: booking.routeName,
                hour: hour,
                type: 'P',
                typeBooking: 'M',
                passenger: passengerName,
                photo: booking.photo,
                numberSeats: numberSeats.length,
                numberParcels: 0,
                seating: totalSeats,
                paymentValue: paymentValue[0].paymentValue,
                status: 'Confirmado',
                statusTrip: 'Programado',
                year: year,
                month: month,
                origen: direction.origenDirection,
                destination: direction.destinationDirection,
                plateNumber: booking.plateNumber,
                travelStatusUid: booking.travelStatusUid,
                color: booking.color,
                brand: booking.brand,
                observation: detail,
                wayPay: 'Efectivo',
                invoice: invoice,
                observationBooking: []
            }

            const travelStatus = {
                cod: cod,
                date: booking.date,
                driver: booking.driver,
                driverId: booking.driverId,
                travelStatusUid: booking.travelStatusUid,
                plateNumber: booking.plateNumber,
                contactNumber: booking.contactNumber,
                origen: routeName[0],
                destination: routeName[1],
                hour: hour,
                numberPassengers: totalSeats.length,
                totalParcels: booking.parcels.length,
                onBoard: 0,
                year: year,
                month: month,
                status: 'Programado',
            }
            travelStatusArray.push(travelStatus)
            bookingHistoryArray.push(bookingHistory)
        })

        const data = {
            companyName: companyName,
            idCompany: idCompany,
            bookings: bookings,
            bookingHistory: bookingHistoryArray,
            travelStatus: travelStatusArray,
            logoUrl: logoUrl,
            hour: hour,
            tokenPush: tokenPush,
            contactNumbers: contactNumbers,
            toMail: dataPassengers.email,
            passengerName: passengerName
        };

        setShowPanel(true);

        await axios.post(url, data, {headers: headers})
            .then(res => {
                if (res.data === 'OK') {
                    setShowPanel(false);
                    setSuccess(true)
                    customScroll('bottom-element', 500)
                    setTimeout(() => {
                        setSuccess(false)
                        setVisibleGrid(true)
                        setReservationManual(false)
                        setTokenPush([])
                    }, 2000)
                }
                if (res.data === 'NM') {
                    setShowPanel(false);
                    NotiStackInfo('Se ha generado la encomienda, pero el correo electronico no ha sido enviado', 'warning', enqueueSnackbar);
                    setSuccess(false)
                    setVisibleGrid(true)
                    setReservationManual(false)
                    setTokenPush([])
                }

                if (res.data === 'ERROR') {
                    setShowPanel(false);
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
                }
            }).catch((e) => {
                console.log(e)
                setShowPanel(false);
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
            })
    }

    return (
        <>
            <LayoutChild center percent={100} padding={15} row color={'#EEF4FD'}>
                <LayoutChild percent={50}>
                    <Text hover={false} text={`Viaje para`} size={14} weight={'700'}/>
                    <Text hover={false} text={`${dataPassengers?.name} ${dataPassengers?.lastName}`} size={12}/>
                    <Text hover={false} text={`${bookings[0].passengers[0].coords.origenCity} `} size={9}/>
                    <Text hover={false} text={`${bookings[0]?.date} a las ${hour} `} size={9}/>
                </LayoutChild>
                <LayoutChild percent={50}>
                    <Layout column>
                        <Text hover={false} text={`Destino ${bookings[0].passengers[0].coords.destinyCity}`} size={14}
                              weight={'700'}/>
                        <Text hover={false} text={`Conductor ${driver} `} size={9}/>
                    </Layout>
                </LayoutChild>
            </LayoutChild>
            <VerticalSpace space={10}/>
            <Invoice setInvoice={setInvoice} invoice={invoice} setPopupVisible={setPopupVisible}
                     popupVisible={popupVisible}/>

            <LayoutChild percent={100} padding={10} row space center>
                <CheckBox value={checkBoxValue} onValueChanged={onValueChanged} text={'Lleva equipaje ?'}/>
                <Button icon="far fa-file-alt" text="Factura"  id={'action-buttons'}
                        onClick={() => setPopupVisible(true)}
                />
            </LayoutChild>
            {checkBoxValue &&
            <LayoutChild percent={100} padding={10}>
                <Text hover={false} text={'Detalle'} size={12}/>
                <TextArea
                    height={90}
                    onValueChanged={(e) => updateDetails(e.value)}
                    value={detailValue}/>
            </LayoutChild>
            }
            <LayoutChild padding={10}>
                <VerticalSpace space={10}/>
                <Text hover={false} size={14} text={'Asientos'} weight={'700'}/>
                <VerticalSpace space={10}/>
                <DashedLine/>
                <VerticalSpace space={10}/>
                {bookings.map((booking, i) => {
                    //  console.log(booking.passengers)
                    const passengerName = `${dataPassengers.name} ${dataPassengers.lastName}`;
                    const getPassenger = Filters(booking.passengers, 'name', passengerName);

                    let paymentValue;

                    if (getPassenger.length > 1) {
                        paymentValue = getPassenger[getPassenger.length - 1].paymentValue
                    } else {
                        paymentValue = getPassenger[0].paymentValue;
                    }

                    const seats = Filters(booking.seating, 'reservation', true);
                    return (
                        <Layout key={i}>
                            {paymentValue > 0 &&
                            <Layout row space>
                                {seats.length > 0 &&
                                <LayoutChild row center>
                                    <VerticalSpace space={10}/>
                                    <Text hover={false} size={12} text={booking.brand} weight={'600'}/>
                                    {seats.map((seat, k) => {
                                        return (
                                            <LayoutChild color={'transparent'} row key={k} center>
                                                <Text hover={false} size={10} text={seat.description} weight={'600'}
                                                      left={7} color={'gray'}/>
                                            </LayoutChild>
                                        );
                                    })}

                                </LayoutChild>
                                }
                                <LayoutChild color={'transparent'}>
                                    <Text hover={false} size={12} text={` $ ${paymentValue}`} weight={'500'}/>
                                </LayoutChild>
                            </Layout>
                            }
                            <div style={{height: 10}}/>
                        </Layout>
                    );
                })}
                <VerticalSpace space={10}/>
                <DashedLine/>
                <VerticalSpace space={10}/>
                <Layout color={'transparent'} row center space>
                    <Text hover={false} size={12} text={'Forma de pago'} weight={'500'}/>
                    <Text hover={false} size={12} text={'Efectivo'} weight={'400'}/>
                    <LayoutChild color={'transparent'} row center>
                        <Text hover={false} size={12} text={'Total a pagar :'} weight={'700'}/>
                        <Text hover={false} size={12} text={`$ ${total.toFixed(2)}`} weight={'700'}
                              color={'#32B859'} left={7}/>
                    </LayoutChild>
                </Layout>
                <VerticalSpace space={30}/>
                {success && <Alerts severity={'success'} body={'Reserva generada exitosamente'}/>}
                <VerticalSpace space={10}/>
                <Layout color={'transparent'} row center positionR>
                    {renderCancelButton()}
                    <Button icon="far fa-check-circle" text="Reservar" width={150} id={'button-save'}
                            onClick={onSaveReservation} type='success'/>
                </Layout>
            </LayoutChild>
            <VerticalSpace space={10}/>
            <Element name="bottom-element" className="element"/>
            <ComponentLoadPanel showLoadPanel={showPanel} message={'Creando reserva...'} time={4000}/>
        </>
    )
}


export default Details